export const puapYears = [
    ...Array.from(
      { length: new Date().getFullYear() + 1 - 1990 + 1 },
      (_, i) => (new Date().getFullYear() + 1 - i).toString()
    ),
    "Older than 1990",
  ];
